module.exports = __webpack_public_path__ + "static/workshops_preview.793589a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/navigation/workshops_preview.jpg
// module id = 694
// module chunks = 213534597649335